<template>
    <div class="gglist">
        <div class="top" v-show="dataLoding == 1">
            <Table style="width: 100%;margin-top: 30px;" :columns="titleNameS" :data="tableList.tableData"  ref="selection"></Table>
        </div>
        <Spin fix class="bottom" v-show="dataLoding == 2">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    
    </div>
</template>

<script>
/**
 * 没有采用下拉查看图片
 * 
 */
import common from '@/common/common.js';
export default {
    name:'editad',
    components: {
    },
    props: {
        params: {
            type:Object,
            default:{}
        },
        titleNameS:{
            type:Array,
            default:[]
        }
    },
    data () {
        return {
            dataLoding:1,
            loading: true,
            type:1,//弹框打开类型 1添加 2编辑
            tableList:{
                tableData:[]
            },
            titleName: [
                {
                    title: '',
                    'title-zh-CN':'图片',
                    'title-en-US':'Photos',
                    key: 'photos',
                    minWidth:180,
                    render: (h, params) => {
                        return h('img', {
                            style: {//设置样式
                                'width': 'auto',
                                'height': '64px',
                                'padding':'4px 0',
                                'border-radius': '5%',
                            },
                            attrs: {//设置属性
                                src: this.config.sourceUrl +'?fid='+imgurl
                            },
                            on:{
                                'on-click':() => {
                                //    console.log(123)
                                    
                                }
                            }
                        });
                    }
                },
                {
                    title: '',
                    'title-zh-CN':'名称',
                    'title-en-US':'Name',
                    key: 'emp_name',
                    minWidth: 80,
                }
            ]
        }
    },

    methods: {
        cahnegid(){
            // console.log(111)
           this.$emit('changesi',this.params)
        },
        getData () {//获取广告
            this.tableList.tableData = params.photos.split(',')
        }
    },
    created(){
        // console.log(9999)
        // console.log(this.params)
    },
    watch:{
       params:{
           deep:true,
           handler:(newval)=>{
            //   console.log(newval)
            // console.log(1111)
           }
       }
    },
    mounted(){
       this.getData();
          
     }
}
</script>
<style scope>
.ivu-poptip-confirm .ivu-poptip-body .ivu-icon{
    left: 20px;
}
td.ivu-table-expanded-cell{
    padding: 10px !important;
}
.gglist .ivu-table th{
    height: 30px !important;
}

</style>


